import React,{useState, useEffect, useRef} from "react"
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import moment from 'moment'
import { facultyposlists } from '../../../apis/urls'
import { degreeurl,mailsend } from '../../../apis/urls'
import { schoolFacultyurl } from '../../../apis/urls'
import DatePicker from "react-datepicker";
import { Multiselect } from "multiselect-react-dropdown";


const AddFaculty = () =>{
  
  
    useEffect(() => {
        PositionListing();
        //DegreeListing();
    },[]
    );

    const [fresult,setFresult] = useState([]);
    //const [dresult,setDresult] = useState([]);

    const [title,setTitle] = useState('');
    const [fname,setFname] = useState('');
    const [mname,setMname] = useState('');
    const [lname,setLame] = useState('');
    const [appointed_date,setAppointed_date] = useState('');
    const [email,setEmail] = useState('');
    const [phone,setPhone] = useState('');
    const [cellphone,setCellphone] = useState('');
    const [fax,setFax] = useState('');
    const [positionid,setPositionid] = useState([]);
    //const [degreeid,setDegreeid] = useState('');
    const [status,setStatus] = useState('');
    const firstRender = useRef(true);
    const [disable, setDisabled] = useState(true);
    const [titleerror,setTitleerror] = useState(false);
    const [fnameerror,setFnameerrorr] = useState(false);
    const [lnameerror,setLnameerror] = useState(false);
    const [appoinerror,setAppoinerror] = useState(false);
    const [emailerror,setEmailerror] = useState(false);
    const [phoneerror,setPhoneerror] = useState(false);
    const [positionerror,setPositionerror] = useState(false);
    const [phonevalidError, setPhoneValidError] = useState(null);
    const [emailvaliderror, setEmailValidErrors] = useState(null);

    //const [degreeerror,setDegreeerror] = useState(false);

    
 
    let facArray = []
    


    const { id } = useParams();
    const username = localStorage.getItem('username')

    let navigate = useNavigate();
    const RoutToList = () =>{
        let path = 'newPath'; 
        navigate("/school_list/faculty/"+id)
    }

    const PositionListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: facultyposlists+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setFresult(response.data.data.items);
            //console.log(response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    } 


    const handleSelect = (id) => {
        // setSchool_id(id)
            id?.map((item,index) => {
                facArray.push(item.id)
            }
            
            )
            setPositionid(facArray)
            console.log(facArray)
            return facArray;
    };
    
    
    const handleRemove = (id) => {
        console.log(id)
    };
   

    const OnFormClick = (school_id) => {

        let error = 0;

        if(title === '')
        {
            setTitleerror(true)
            error =1;
        }
        if(fname === '')
        {
            setFnameerrorr(true)
            error = 1;
            
        }
        if(lname === '')
        {
            setLnameerror(true)
            error = 1;
            
        }

        if(appointed_date === '')
        {
            setAppoinerror(true)
            error = 1;
            
        }
        if(email === '')
        {
            setEmailerror(true)
            error = 1;
            
        }

        if(phone === '')
        {
            setPhoneerror(true)
            error = 1;
        }
        if(positionid === '')
        {
            setPositionerror(true)
            error = 1;
        }


    if(error === 0) 
    {
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)
        const data = {
            title :title,
            first_name :fname,
            middle_name:mname,
            last_name:lname,
            appointed_date:moment(appointed_date).format('MM-DD-YYYY'),
            email:email,
            phone:phone,
            cell_phone :cellphone,
            fax :fax,
            school_id:id,
            position_id:positionid,
            status :'ACTIVE'
        }
        console.log(data)
        const instance = axios.create({

            baseURL: schoolFacultyurl+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.post('',data).then((response) =>{

            console.log(response.data)
            
            let path = 'newPath'; 
            navigate("/school_list/faculty/"+id) 

            // MAIL SENDING

            // let token = "Bearer "+localStorage.getItem('token');
            // console.log(token)
            // const data = {
            //     name: 'Praveen',
            //     current_login:username,
            //     facultyname:fname,
            //     new:'new',
            //     action:'Created',
            // }
            
            // const instance = axios.create({

            //     baseURL: mailsend,

            //     timeout: 1000000,

            //     headers: {'authorization': token}

            // });
            
            // instance.post('',data).then((response) =>{
            //     console.log("mail send successfully")

            // }).catch((error) =>{
                
            //    console.log('error in sending',error)

            // });



        // END MAIL SENDING


           
          }).catch((error) =>{
            
            //console.log('error',error.message)

            //setNameerror('Enter the Name')
            

          });
    }
       
        



    }

    useEffect(() => {
        if (firstRender.current) {
          firstRender.current = false;
          return;
        }

        const formPhoneValidation = () => {
           
            const phoneValidation =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    
            if((phone.match(phoneValidation))){
           // if (phoneValidation) {
              setPhoneValidError(null);
            } else {
              setPhoneValidError("Phone number is invalid");
            }
          };
          setDisabled(formPhoneValidation());

          const formValidation = () => {
            const emailValidation = !/\S+@\S+\.\S+/.test(email);
              if (emailValidation) {
                setEmailValidErrors("Email address is invalid");
              } else {
                setEmailValidErrors(null);
              }
            };
           setDisabled(formValidation());
  


    },[phone, email])

    

    

    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">
			
            <div className="page-title-wrpr">
                <div className="page-title-left-column">
                    
                    <h2 className="page-title">Add Admin/Staff</h2>
                </div>
                <div className="page-rightside-action-column">
                    
                    
                </div>
                
                
            </div>
            
            
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to={"/school_list/faculty/"+id}>Admin/Staff</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Admin/Staff</li>
              </ol>
            </nav>
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="degreehead">Title <span style={{color: "red"}}>*</span></label>
                            {/* <input type="text" className="form-control bg-dark dark-theme showtext" value={title} onChange={e => {setTitle(e.target.value)}} placeholder="Enter Title" id="name"></input> */}

                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setTitle(e.target.value)}} id="status-selector">
                                
                                <option value="0">Select Title</option>
                                
                                <option value="Dr.">Dr.</option>
                                <option value="Mr.">Mr.</option>
                                <option value="Mrs.">Mrs.</option>
                                <option value="Ms.">Ms.</option>
                                <option value="Miss.">Miss.</option>
                                        
                            </select>

                            {
                                titleerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Title</div>
                                :null
                            }

                        </div>
                        <div className="form-group">
                            <label className="degreehead">First Name <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={fname} onChange={e => {setFname(e.target.value)}} placeholder="Enter First Name" id="name"></input>
                            {
                                fnameerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The First Name</div>
                                :null
                            }
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Middle Name</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={mname} onChange={e => {setMname(e.target.value)}} placeholder="Enter Middle Name" id="name"></input>
                            
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Last Name <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={lname} onChange={e => {setLame(e.target.value)}} placeholder="Enter Last Name" id="name"></input>
                            {
                                lnameerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Last Name</div>
                                :null
                            }
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Appointed Date <span style={{color: "red"}}>*</span></label>
                            {/* <input type="date" className="form-control bg-dark dark-theme showtext" value={appointed_date} onChange={e => {setAppointed_date(e.target.value)}} id="name"></input> */}
                            <DatePicker
											className="form-control justshow bg-dark"
											selected={appointed_date}
                                            onChange={(date) => setAppointed_date(date)}
											value={appointed_date}
											isClearable
											placeholderText="Enter Appointed_Date (MM/DD/YYYY)"
											showMonthDropdown={true}
											showYearDropdown={true}
											scrollableYearDropdown={false}
										/>
                            
                            {
                                appoinerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Appointed Date</div>
                                :null
                            }
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Email <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={email} onChange={e => {setEmail(e.target.value)}} placeholder="Enter The Email" id="name"></input>
                            {
                                emailerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Email</div>
                                :<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailvaliderror && <p>{emailvaliderror}</p>}</div>
                            }
                        </div>
                        <div className="form-group">
                            <label className="degreehead">School Phone <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={phone} onChange={e => {setPhone(e.target.value)}} placeholder="Enter The Phone (XXX-XXX-XXXX)" id="name"></input>
                        
                            {
                                phoneerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Phone</div>
                                :<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{phonevalidError && <p>{phonevalidError}</p>}</div>
                            }
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Cell Phone</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={cellphone} onChange={e => {setCellphone(e.target.value)}} placeholder="Enter The Cell Phone (XXX-XXX-XXXX)" id="name"></input>
                        </div>

                        {/* <div className="form-group">
                            <label className="degreehead">Fax</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={fax} onChange={e => {setFax(e.target.value)}} placeholder="Enter The Fax" id="name"></input>
                        </div> */}
                        <div className="form-group">
                            <label className="degreehead">Positions <span style={{color: "red"}}>*</span></label>
                            {/* <select className="form-control bg-dark dark-theme showtext" onChange={e => {setPositionid(e.target.value)}} id="status-selector">
                                <option value="0">Select Job Position</option>
                                {
                                    fresult?.map((item,index)=>(
                                        
                                        <option key={index} value={item.id}>{item.name}</option>
                                        
                                    )
                                    
                                    )
                                }
                             
                            </select>

                            {
                                positionerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select Position</div>
                                :null
                            } */}

                                <Multiselect
                                    options={fresult}
                                    value={facArray}
                                    onSelect={handleSelect}
                                    onRemove={handleRemove} 
                                    displayValue="name" />

                                    {
                                        positionid.length === 0 && <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select Position</div>
                                    }


                        </div>
                        <h6 style={{color: "red"}}>* Required Fields</h6>
                        
                        <div className="form-group text-right">
                        <button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
                            <button onClick={ ()=> { OnFormClick(id) } } className="btn btn-primary btn-gisa" type="button">Create</button>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </div>
            </aside>
        </div>
    )
}

export default AddFaculty;


